import axios from "axios";
import { API_SUBSCRIPTION_KEY, API_URL } from "environment";

export default axios.create({
  baseURL: API_URL,
  headers: { "x-subscriptionkey": API_SUBSCRIPTION_KEY },
});
